export default function Dashboard() {
  return (
    <section id="dashboard" className="py-24 bg-gradient-to-b from-black to-[#0d1b2a]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-0 bg-white rounded-2xl overflow-hidden shadow-2xl">
          {/* 左侧数据大屏 */}
          <div className="relative bg-[#f8f6f0] p-12">
            <div className="mb-8">
              <div className="inline-block px-4 py-2 bg-gray-200 rounded-full mb-4">
                <span className="text-gray-600 text-xs tracking-widest">REAL-TIME DASHBOARD</span>
              </div>
              <h3 className="text-5xl font-black text-gray-900 leading-tight">
                智能<br />指挥<br />中枢
              </h3>
            </div>

            {/* 仪表盘预览 */}
            <div className="relative w-full h-96 bg-white rounded-lg shadow-lg overflow-hidden">
              <img 
                src="https://public.readdy.ai/ai/img_res/2387c72ac309362b7e1109e047ff0ec0.jpg"
                alt="数据驾驶舱"
                className="w-full h-full object-cover"
              />
              
              {/* 模拟数据叠加 */}
              <div className="absolute top-4 left-4 right-4">
                <div className="bg-white/90 backdrop-blur-sm rounded-lg p-4 shadow-lg">
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-xs text-gray-600">实时监控</span>
                    <span className="text-xs text-green-600 flex items-center gap-1">
                      <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></span>
                      在线
                    </span>
                  </div>
                  <div className="grid grid-cols-3 gap-4">
                    <div>
                      <div className="text-2xl font-bold text-gray-900">24</div>
                      <div className="text-xs text-gray-500">无人机</div>
                    </div>
                    <div>
                      <div className="text-2xl font-bold text-gray-900">12</div>
                      <div className="text-xs text-gray-500">任务中</div>
                    </div>
                    <div>
                      <div className="text-2xl font-bold text-gray-900">3</div>
                      <div className="text-xs text-gray-500">预警</div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="absolute bottom-4 left-4 right-4">
                <div className="bg-red-500/90 backdrop-blur-sm rounded-lg p-3 shadow-lg">
                  <div className="flex items-center gap-2">
                    <i className="ri-alert-line text-white"></i>
                    <span className="text-xs text-white font-medium">3号码头检测到未授权人员闯入</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 右侧说明 */}
          <div className="flex flex-col items-center justify-center p-12 bg-white">
            <div className="text-center max-w-md">
              <h3 className="text-4xl md:text-5xl font-black text-gray-900 mb-6 leading-tight">
                一屏掌控<br />全局态势
              </h3>
              <p className="text-lg text-gray-600 leading-relaxed mb-8">
                整合海陆空天多维数据,实时监控港区运营状态,智能预警异常事件,辅助管理者快速决策
              </p>
              <button className="px-8 py-4 bg-gray-900 text-white font-medium rounded-full hover:bg-gray-800 transition-colors flex items-center gap-2 mx-auto cursor-pointer whitespace-nowrap">
                申请演示账号
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}